import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import './DICOMDetail.css';

const DICOMDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [dicom, setDicom] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/patients/dicoms/${id}/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => {
        setDicom(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError('Error fetching XA DICOM details');
        setLoading(false);
      });
  }, [id, token]);

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this XA DICOM?")) {
      axios
        .delete(`${process.env.REACT_APP_BACKEND_URL}/patients/dicoms/${id}/delete/`, {
          headers: { Authorization: `Token ${token}` },
        })
        .then(() => {
          navigate("/dicoms");
        })
        .catch((err) => {
          alert("Error deleting XA dicom");
        });
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!dicom) return <p>No XA DICOM found.</p>;

  return (
    <div className="dicom-detail-container">
      <h3>XA DICOM Detail</h3>
      <p><strong>ID:</strong> {dicom.id}</p>
      <p><strong>Patient:</strong> {dicom.patient}</p>
      <p><strong>File Path:</strong> {dicom.file_path}</p>
      <p><strong>Study ID:</strong> {dicom.study}</p>
      <p><strong>Series ID:</strong> {dicom.series_id}</p>
      <p><strong>Side:</strong> {dicom.side}</p>
      <p><strong>Primary Angle:</strong> {dicom.primary_angle}</p>
      <p><strong>Secondary Angle:</strong> {dicom.secondary_angle}</p>
      <p>
        <strong>Labels:</strong>{" "}
        {dicom.labels
          ? JSON.stringify(dicom.labels)
          : "None"}
      </p>
      <p><strong>Dev Notes:</strong> {dicom.dev_notes}</p>
      <p><strong>Original Upload Path:</strong> {dicom.original_upload_path}</p>
      <p><strong>All Images Dir:</strong> {dicom.all_images_dir}</p>
      <div className="dicom-detail-actions">
        <button type="submit" className="dicom-edit-btn">
          Update DICOM
        </button>
          <button onClick={handleDelete}>Delete</button>
        </div>
    </div>
  );
};

export default DICOMDetail;
